import type { Components } from "react-markdown";
import CheckCircle from "@/components/ui/CheckCircle";

/** react-markdown overrides used for objective check-circle lists (`ul` / `li` only). */
type ObjectivesListMapping = Pick<Components, "ul" | "li">;

/**
 * Tag → renderer mapping for intro/outro objective lists — check-circle rows
 * with heading-scale body text. Shared by ChapterIntroScroll and SectionContent.
 */
const objectivesListMapping: ObjectivesListMapping = {
  ul: ({ children }) => (
    <ul className="not-prose my-6 flex flex-col gap-3">{children}</ul>
  ),
  li: ({ children }) => (
    <li className="flex items-center gap-3">
      <CheckCircle />
      <span className="text-h4 leading-body text-foreground">{children}</span>
    </li>
  ),
};

export { objectivesListMapping };
export type { ObjectivesListMapping };
